<template>
  <div>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Row style="padding:0px 0px 10px 0px">
      <Col span="24">
        <Page
          :current="currentPage"
          :total="dataCount"
          :page-size="pageSize"
          show-sizer
          show-total
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          simple
        ></Page>
      </Col>
    </Row>
    <Table
      ref="selectionTable"
      :max-height="height * 0.8"
      :data="showData"
      :columns="columns"
      stripe
      border
    ></Table>
  </div>
</template>

<script>
import expandMonthRecordRow from "../expand/tableMonthRecordExpand.vue";
export default {
  components: {
    expandMonthRecordRow
  },
  mounted() {},
  data() {
    return {
      height: window.innerHeight,
      width: window.innerWidth,
      isSpinShow: false,
      currentPage: 1,
      dataCount: 0,
      pageSize: 10,
      showData: [],
      columns: [],
      expandMonthRecordColumn: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(expandMonthRecordRow, {
              props: {
                row: params.row
              }
            });
          }
        }
      ]
    };
  },
  methods: {
    setMeter(param) {
      this.meterId = param;
      this.showPage();
    },
    showPage() {
      let that = this;
      that.isSpinShow = true;
      $.ajax({
        url:
          "/api/instructions/searchUpInstructions?page=" +
          that.currentPage +
          "&pageAmount=" +
          that.pageSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          commandDeviceId: that.meterId,
          commandType: "0x24"
        }),
        dataType: "json",
        success: function(receiveData) {
          if (receiveData.errorCode == 0) {
            that.showData = receiveData.body.resultList;
            that.dataCount = receiveData.body.amount;
            if (that.dataCount > 0) {
              that.columns = that.expandMonthRecordColumn.concat(
                receiveData.body.columns.map((val, index) => {
                  if (index === 0) {
                    val.fixed = "left";
                  }
                  if (index < 10) {
                    val.title = val.title.replace("1", "");
                  }
                  val.width = that.width * 0.4;
                  return val;
                })
              );
              for (var i = that.columns.length - 1; i >= 0; i--) {
                if (
                  that.columns[i].key == "record2Flow" ||
                  that.columns[i].key == "record2StandardFlow" ||
                  that.columns[i].key == "record2Time" ||
                  that.columns[i].key == "record2cost" ||
                  that.columns[i].key == "record3Flow" ||
                  that.columns[i].key == "record3StandardFlow" ||
                  that.columns[i].key == "record3Time" ||
                  that.columns[i].key == "record3cost" ||
                  that.columns[i].key == "record4Flow" ||
                  that.columns[i].key == "record4StandardFlow" ||
                  that.columns[i].key == "record4Time" ||
                  that.columns[i].key == "record4cost" ||
                  that.columns[i].key == "record5Flow" ||
                  that.columns[i].key == "record5StandardFlow" ||
                  that.columns[i].key == "record5Time" ||
                  that.columns[i].key == "record5cost" ||
                  that.columns[i].key == "record6Flow" ||
                  that.columns[i].key == "record6StandardFlow" ||
                  that.columns[i].key == "record6Time" ||
                  that.columns[i].key == "record6cost" ||
                  that.columns[i].key == "record7Flow" ||
                  that.columns[i].key == "record7StandardFlow" ||
                  that.columns[i].key == "record7Time" ||
                  that.columns[i].key == "record7cost" ||
                  that.columns[i].key == "record8Flow" ||
                  that.columns[i].key == "record8StandardFlow" ||
                  that.columns[i].key == "record8Time" ||
                  that.columns[i].key == "record8cost" ||
                  that.columns[i].key == "record9Flow" ||
                  that.columns[i].key == "record9StandardFlow" ||
                  that.columns[i].key == "record9Time" ||
                  that.columns[i].key == "record9cost" ||
                  that.columns[i].key == "record10Flow" ||
                  that.columns[i].key == "record10StandardFlow" ||
                  that.columns[i].key == "record10Time" ||
                  that.columns[i].key == "record10cost" ||
                  that.columns[i].key == "record11Flow" ||
                  that.columns[i].key == "record11StandardFlow" ||
                  that.columns[i].key == "record11Time" ||
                  that.columns[i].key == "record11cost" ||
                  that.columns[i].key == "record12Flow" ||
                  that.columns[i].key == "record12StandardFlow" ||
                  that.columns[i].key == "record12Time" ||
                  that.columns[i].key == "record12cost"
                ) {
                  that.columns.splice(i, 1);
                }
              }
            } else {
              that.columns = [];
            }
          } else {
            that.$Notice.error({
              title: "异常",
              desc: receiveData.errorInfo
            });
          }
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isSpinShow = false;
        }
      });
    },
    changePage(index) {
      this.currentPage = index;
      this.showPage();
    },
    changePageSize(size) {
      this.pageSize = size;
      this.showPage();
    }
  }
};
</script>

<style>
</style>
